module.exports = __webpack_public_path__ + "img/homechecf.6b9f3585.jpeg";